/**
 * "just now", "3 min ago", "2 h ago", "yesterday", "Oct 12": how long ago
 * something was, the way a status line says it.
 */
export function timeAgo(then: Date, now: Date = new Date()): string {
  const seconds = Math.max(0, Math.round((now.getTime() - then.getTime()) / 1000))
  if (seconds < 45) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} h ago`
  if (hours < 48) return 'yesterday'
  return then.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

/**
 * "36 minutes ago", "3 days ago", "2 months ago", "a year ago": how long ago
 * something last changed, in words, as a list's "Last updated" column says
 * it. Rounds the way people do — 40 minutes is "40 minutes", 50 is "an hour";
 * 25 days is "25 days", 30 is "a month".
 */
export function longAgo(then: Date, now: Date = new Date()): string {
  const seconds = Math.max(0, (now.getTime() - then.getTime()) / 1000)
  const minutes = seconds / 60
  const hours = minutes / 60
  const days = hours / 24
  const count = (n: number, one: string, unit: string) =>
    Math.round(n) <= 1 ? `${one} ago` : `${Math.round(n)} ${unit} ago`
  if (seconds < 45) return 'a few seconds ago'
  if (minutes < 45) return count(minutes, 'a minute', 'minutes')
  if (hours < 22) return count(hours, 'an hour', 'hours')
  if (days < 26) return count(days, 'a day', 'days')
  if (days < 320) return count(days / 30.44, 'a month', 'months')
  return count(days / 365.25, 'a year', 'years')
}
